import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../../../../environments/environment';
import { SessionQuery } from '../../../session/session.query';

@Component({
	selector: 'app-ad-image-preview-dialog',
	templateUrl: './ad-image-preview-dialog.component.html',
	styleUrl: './ad-image-preview-dialog.component.scss'
})
export class AdImagePreviewDialogComponent {
	isLoading = true;
	isDownloading = false;

	constructor(
		public ref: MatDialogRef<AdImagePreviewDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		private snackBar: MatSnackBar,
		private sessionQuery: SessionQuery
	) {}

	onImageLoad(): void {
		this.isLoading = false;
	}

	copyUrl(): void {
		if (this.data?.assetPath) {
			navigator.clipboard.writeText(this.data.assetPath).then(() => {
				this.snackBar.open('URL copied to clipboard', 'OK', {
					duration: 2000,
					horizontalPosition: 'center',
					verticalPosition: 'bottom'
				});
			});
		}
	}

	async downloadImage(): Promise<void> {
		if (!this.data?.assetPath || this.isDownloading) return;

		this.isDownloading = true;
		const filename = this.getDownloadFilename();

		try {
			// Use our download proxy endpoint with authentication
			const downloadUrl = `${environment.apiUrl}/asset/download-proxy?url=${encodeURIComponent(this.data.assetPath)}&filename=${encodeURIComponent(filename)}`;
			const token = this.sessionQuery.getToken();

			const response = await fetch(downloadUrl, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			if (!response.ok) {
				throw new Error(`Download failed: ${response.status}`);
			}

			// Create blob and trigger download
			const blob = await response.blob();
			const blobUrl = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			// Clean up blob URL
			window.URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error('Download failed:', error);
			this.snackBar.open('Failed to download image', 'OK', {
				duration: 3000,
				horizontalPosition: 'center',
				verticalPosition: 'bottom'
			});
		} finally {
			this.isDownloading = false;
		}
	}

	private getDownloadFilename(): string {
		const title = this.data.title || 'image';
		// Extract extension from URL if available
		const url = this.data.assetPath;
		const urlParts = url.split('?')[0].split('.');
		const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1] : 'png';
		// Add extension if title doesn't have one
		if (!title.includes('.')) {
			return `${title}.${extension}`;
		}
		return title;
	}

	close() {
		this.ref.close();
	}
}
